import React from "react";
import PropTypes from "prop-types";

const PopupInput = ({ label, required, inputType, ...props }) => (
  <div className="flex-1">
    <span className=" font-semibold">
      {label} {required ? <span className="text-red-500">*</span> : ""}
    </span>
    <div className="flex items-center space-x-2">
      {inputType === "input" && (
        <input
          className="flex-1  border-[1px] border-gray-200 px-2 py-1 text-xs focus:ring-0 focus:border-secondary invalid:border-red-600"
          {...props}
        />
      )}
      {inputType === "textarea" && (
        <textarea
          className="flex-1  border-[1px] border-gray-200 focus:ring-0 focus:border-secondary px-2 py-1 text-xs"
          {...props}
        />
      )}
    </div>
  </div>
);

PopupInput.propTypes = {
  label: PropTypes.string,
  required: PropTypes.bool,
  inputType: PropTypes.string
};

PopupInput.defaultProps = {
  label: null,
  required: false,
  inputType: "input"
};

export default PopupInput;
